<button
  [textColor]="isAuthorized ? 'success' : 'danger'"
  size="sm"
  eBtn
  (click)="$event.stopPropagation(); onToggleFeature(feature, node.navigationItem)"
  squared
  [icon]="isAuthorized ? 'check' : 'ban'"
></button>
